// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__csK1a","info":"UpdateTermsInfo_info__57MXo"};